import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/lib/auth";

export function useWorkspaceId() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["workspace-id", user?.id],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_user_workspace_id");
      if (error) throw error;
      return data as string;
    },
    enabled: !!user,
    staleTime: Infinity,
  });
}
